




















import { mapGetters } from 'vuex';
import { TTabsItem } from '@/api/schema';
import { EPermissionSuperAdmin } from '@/plugins/role-permissions/types/permission-subject';
import FeatureFlagRedirectMixin from '@/mixins/copy-stake/FeatureFlagRedirectMixin';
import { getShowCredentialsConfiguration } from '@/api/CopyStake/Settings';
import type { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';

const CopyStakeSettingsBetAmount = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsBetAmount.vue'
  );
const CopyStakeSettingsLiveKitCredentials = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsLiveKitCredentials.vue'
  );
const CopyStakeSettingsInactivityTimeout = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsInactivityTimeout.vue'
  );
const CopyStakeSettingsAutoclickerUrl = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsAutoclickerUrl.vue'
  );
const CopyStakeSettingsShowOnlyStreamers = (): Promise<any> =>
  import(
    '@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsShowOnlyStreamers.vue'
  );
const CopyStakeSettingsRestream = (): Promise<any> =>
  import('@/views/CopyStake/CopyStakeSettings/CopyStakeSettingsRestream.vue');

export default {
  name: 'CopyStakeSettingsView',
  mixins: [FeatureFlagRedirectMixin],
  components: {
    CopyStakeSettingsBetAmount,
    CopyStakeSettingsLiveKitCredentials,
    CopyStakeSettingsAutoclickerUrl,
    CopyStakeSettingsShowOnlyStreamers,
    CopyStakeSettingsInactivityTimeout,
    CopyStakeSettingsRestream
  },
  data(): any {
    return {
      showCredentials: false,
      isLoading: false
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['operatorId']),
    ...mapGetters('Onboarding', [
      'isCopyStakeGeneralIntegrationMode',
      'isCopyStakeOnFlyCopyMode'
    ]),

    settingsBlock(): TTabsItem[] {
      if (!this.operatorId) return [];

      return [
        {
          id: 'BetAmountSettings',
          text: 'Bet Amount Settings',
          component: 'CopyStakeSettingsBetAmount',
          visible: this.isShowBetAmountSettings
        },
        {
          id: 'LiveKitCredentials',
          text: 'LiveKit Credentials',
          component: 'CopyStakeSettingsLiveKitCredentials',
          visible: this.isShowLiveKitCredentialsSettings
        },
        {
          id: 'AutoclickerUrl',
          text: 'Autoclicker URL settings',
          component: 'CopyStakeSettingsAutoclickerUrl',
          visible: this.isShowAutoclickerUrlSettings
        },
        {
          id: 'ShowOnlyStreamers',
          text: 'Show only streamers',
          component: 'CopyStakeSettingsShowOnlyStreamers',
          visible: this.isShowOnlyStreamersSettings
        },
        {
          id: 'InactivityTimeout',
          text: 'Inactivity Timeout',
          component: 'CopyStakeSettingsInactivityTimeout',
          visible: this.isShowInactivityTimeoutSettings
        },
        {
          id: 'RestreamSettings',
          text: 'Restream settings',
          component: 'CopyStakeSettingsRestream',
          visible: this.isShowRestreamSettings
        }
      ].filter(({ visible }) => visible ?? true);
    },

    isShowBetAmountSettings(): boolean {
      return (
        this.isCopyStakeGeneralIntegrationMode &&
        this.isCopyStakeOnFlyCopyMode
      );
    },
    isShowLiveKitCredentialsSettings(): boolean {
      return (
        this.$role.can.update(
          EPermissionSuperAdmin.SUPER_ADMIN_LIVEKIT_SETTINGS
        ) && !!this.showCredentials
      );
    },
    isShowAutoclickerUrlSettings(): boolean {
      return this.isCopyStakeGeneralIntegrationMode;
    },
    isShowOnlyStreamersSettings(): boolean {
      return (
        this.isCopyStakeGeneralIntegrationMode &&
        this.isCopyStakeOnFlyCopyMode
      );
    },
    isShowInactivityTimeoutSettings(): boolean {
      return this.isCopyStakeGeneralIntegrationMode;
    },
    isShowRestreamSettings(): boolean {
      return this.isCopyStakeGeneralIntegrationMode;
    }
  },
  watch: {
    operatorId: {
      handler: 'getCredentialsConfiguration',
      immediate: true
    }
  },
  methods: {
    async getCredentialsConfiguration(): Promise<void> {
      if (!this.operatorId) {
        return;
      }

      this.isLoading = true;

      getShowCredentialsConfiguration()
        .then((data: boolean) => {
          this.showCredentials = data || false;
        })
        .catch((err: AxiosError): void => {
          errorToastMessage(err);
          this.showCredentials = false;
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
